import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { message } from "antd";
import App from "../../Utils/LayoutMobile";

// ── Theme ────────────────────────────────────────────────────
const C_PINK      = "#F04DA0";
const C_PURPLE    = "#8B2FC9";
const C_GRAD      = `linear-gradient(135deg, ${C_PINK}, ${C_PURPLE})`;
const C_SOFT_BG   = "#F8F4FF";
const C_TEXT_MAIN = "#1a0040";
const C_TEXT_MUTED= "#64748B";

// ── ALL Distance & Amenity Icons (rendered as SVG) ────────────
const ICONS = {
  // Distance icons
  TrainIcon : () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="3" width="16" height="14" rx="2"/><path d="M4 11h16M12 3v8M8 19l-2 3M18 22l-2-3M8 19h8"/></svg>,
  PlaneIcon : () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.8 19.2L16 11l3.5-3.5C21 6 21 4 19.5 2.5S18 2 16.5 3.5L13 7 4.8 5.2C4.4 5.1 4 5.4 4 5.8v.4c0 .3.1.5.4.6L8 9 6 11H4l-1 1 3 2 2 3 1-1v-2l2-2 2.6 3.6c.1.3.4.4.6.4h.4c.4 0 .7-.4.6-.8z"/></svg>,
  PinIcon   : () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  CarIcon   : () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.5 2.9C2.1 10.9 2 11 2 11.1V16c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg>,
  BusIcon   : () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 6v6M3 6h18M16 6v6M2 12l1 5h18l1-5"/><circle cx="7" cy="19" r="1"/><circle cx="17" cy="19" r="1"/><path d="M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3"/></svg>,
  WalkIcon  : () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="13" cy="4" r="2"/><path d="m9 10 2-4 4 2 2 4h-4m-4-2L7 18l4-2 2 4"/></svg>,
  // Amenity icons
  AmCafe    : () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>,
  AmPower   : () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"/><line x1="12" y1="2" x2="12" y2="12"/></svg>,
  AmCouch   : () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"/><path d="M2 11a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4z"/><path d="M4 17v2M20 17v2"/></svg>,
  AmWifi    : () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><circle cx="12" cy="20" r="1" fill="currentColor"/></svg>,
  AmDesk    : () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="3" rx="1"/><path d="M6 10v7M18 10v7M4 17h16"/></svg>,
  AmAc      : () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="6" width="20" height="8" rx="2"/><path d="M7 14v4M12 14v4M17 14v4M7 18h10"/></svg>,
  AmCctv    : () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>,
  AmStage   : () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="14" width="20" height="6" rx="1"/><path d="M6 14V8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v6"/><path d="M10 4h4"/></svg>,
  AmParking : () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 17V7h4a3 3 0 0 1 0 6H9"/></svg>,
  AmSecurity: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
};

const DISTANCE_ICON_KEYS = ["TrainIcon","PlaneIcon","PinIcon","CarIcon","BusIcon","WalkIcon"];
const AMENITY_ICON_KEYS  = ["AmCafe","AmPower","AmCouch","AmWifi","AmDesk","AmAc","AmCctv","AmStage","AmParking","AmSecurity"];

// ── Icon Picker ──────────────────────────────────────────────
function IconPicker({ value, onChange, keys, label }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const Cur = ICONS[value] || (() => null);

  useEffect(() => {
    const fn = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);

  return (
    <div ref={ref} style={{ position:"relative", flexShrink:0 }}>
      <button
        type="button"
        className="icon-pick-btn"
        onClick={() => setOpen(o => !o)}
        title={`Change ${label}`}
      >
        <span style={{ color: C_PURPLE, display:"flex", alignItems:"center" }}><Cur /></span>
        <svg width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" style={{ color:"#9a86b8", marginLeft:2 }}>
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>
      {open && (
        <div className="icon-picker-dropdown">
          <div className="icon-picker-label">Choose icon</div>
          <div className="icon-picker-grid">
            {keys.map(k => {
              const Ic = ICONS[k] || (() => null);
              return (
                <button
                  key={k}
                  type="button"
                  className={`icon-opt ${value === k ? "icon-opt--active" : ""}`}
                  onClick={() => { onChange(k); setOpen(false); }}
                  title={k}
                >
                  <Ic />
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

// ── Image Upload Field ─────────────────────────────
function ImageUploadField({ value, onChange, index }) {
  const fileRef = useRef();

  const handleFile = (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      message.error("Only image files are allowed.");
      return;
    }
    if (file.size > 300 * 1024) {
      message.error(`Image must be under 300 KB. This file is ${(file.size / 1024).toFixed(0)} KB.`);
      return;
    }
    onChange(file);
  };

  let currentPreview = null;
  if (value instanceof File) {
    currentPreview = URL.createObjectURL(value); 
  } else if (value && value.url) {
    currentPreview = value.url; 
  } else if (typeof value === "string" && value.trim() !== "") {
    currentPreview = value; 
  }

  return (
    <div className="img-upload-wrap">
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        style={{ display:"none" }}
        onChange={e => handleFile(e.target.files[0])}
      />
      {currentPreview ? (
        <div className="img-preview-box">
          <img src={currentPreview} alt={`Photo ${index + 1}`} className="img-preview-thumb" />
          <div className="img-preview-actions">
            <button type="button" className="img-act-btn" onClick={() => fileRef.current?.click()} title="Replace">
              <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
              </svg>
              Replace
            </button>
          </div>
          <div className="img-size-badge">#{index + 1}</div>
        </div>
      ) : (
        <div
          className="img-drop-zone"
          onClick={() => fileRef.current?.click()}
        >
          <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" style={{ color:C_PINK }}>
            <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
          </svg>
          <span className="img-drop-label">Click to upload</span>
          <span className="img-drop-hint">Max 300 KB · JPG, PNG</span>
        </div>
      )}
    </div>
  );
}

// ── Floating Preview Component ──────────────────────────────────
function FloatingPreview({ saved }) {
  const [hovered, setHovered] = useState(false);
  const frontendUrl = process.env.REACT_APP_FRONTEND_URL || "https://skinola.in";

  return (
    <a
      href={`${frontendUrl}/Location`}
      target="_blank"
      rel="noreferrer"
      className="float-preview-btn"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      title="Preview on website"
    >
      <span className="float-icon">
        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
        </svg>
      </span>
      <span className={`float-label ${hovered ? "float-label--show" : ""}`}>
        Live Preview
        <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" style={{ marginLeft:5 }}>
          <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/>
          <polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/>
        </svg>
      </span>
      {!saved && <span className="float-dot" title="Unsaved changes" />}
    </a>
  );
}

// ── Icons for form toolbar ───────────────────────────────────
const PlusIcon = () => <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const TrashIcon= () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>;
const SaveIcon = () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>;

// ── Main Component ───────────────────────────────────────────
const ManageHeroVenue = () => {
  const [loading,  setLoading]  = useState(false);
  const [fetching, setFetching] = useState(true);
  const [venueId,  setVenueId]  = useState(null);
  const [saved,    setSaved]    = useState(true);

  const [formData, setFormData] = useState({
    title: "",
    subtitle: "",
    descriptionPart1: "",
    descriptionPart2: "",
    addressBadge: "",
    mapEmbedUrl: "",
    mapAddressText: "",
    photos: [""],
    highlights:  [{ value: "", label: "" }],
    distances:   [{ iconName: "PinIcon",  label: "", value: "" }],
    amenities:   [{ iconName: "AmWifi",   label: "", desc:  "" }],
  });

  const updateForm = (patch) => {
    setFormData(p => ({ ...p, ...patch }));
    setSaved(false);
  };

  // ── Fetch ──
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/venue-details`)
      .then(({ data }) => {
        if (data.success && data.data) {
          const d = data.data;
          setVenueId(d._id);
          setFormData({
            title:            d.title            || "",
            subtitle:         d.subtitle         || "",
            descriptionPart1: d.descriptionPart1 || "",
            descriptionPart2: d.descriptionPart2 || "",
            addressBadge:     d.addressBadge     || "",
            mapEmbedUrl:      d.mapEmbedUrl      || "",
            mapAddressText:   d.mapAddressText   || "",
            photos:           d.photos?.length    ? d.photos      : [""],
            highlights: d.highlights?.length ? d.highlights : [{ value:"", label:"" }],
            distances:  d.distances?.length  ? d.distances  : [{ iconName:"PinIcon", label:"", value:"" }],
            amenities:  d.amenities?.length  ? d.amenities  : [{ iconName:"AmWifi",  label:"", desc:"" }],
          });
          setSaved(true);
        }
      })
      .catch(() => console.log("No existing venue, starting fresh."))
      .finally(() => setFetching(false));
  }, []);

  const handleChange = (e) => updateForm({ [e.target.name]: e.target.value });

  const handleArrayChange = (field, index, key, value) => {
    const updated = [...formData[field]];
    if (key) updated[index] = { ...updated[index], [key]: value };
    else     updated[index] = value;
    updateForm({ [field]: updated });
  };

  const addArrayItem = (field, defaultObj) => updateForm({ [field]: [...formData[field], defaultObj] });

  const removeArrayItem = (field, index) => {
    const updated = [...formData[field]];
    updated.splice(index, 1);
    updateForm({ [field]: updated });
  };

  // ── Submit ──
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const fd = new FormData();

      fd.append("title", formData.title);
      fd.append("subtitle", formData.subtitle);
      fd.append("descriptionPart1", formData.descriptionPart1);
      fd.append("descriptionPart2", formData.descriptionPart2);
      fd.append("addressBadge", formData.addressBadge);
      fd.append("mapEmbedUrl", formData.mapEmbedUrl);
      fd.append("mapAddressText", formData.mapAddressText);

      fd.append("highlights", JSON.stringify(formData.highlights));
      fd.append("distances", JSON.stringify(formData.distances));
      fd.append("amenities", JSON.stringify(formData.amenities));

      const validPhotos = formData.photos.filter(p => p !== "");
      const newFiles = validPhotos.filter(p => p instanceof File);
      
      newFiles.forEach(file => {
        fd.append("photos", file);
      });

      const config = { headers: { "Content-Type": "multipart/form-data" } };

      if (venueId) {
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/v1/venue-details/${venueId}`, fd, config);
        message.success("Venue details updated successfully!");
      } else {
        const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/venue-details`, fd, config);
        setVenueId(res.data.data._id);
        message.success("Venue details created successfully!");
      }
      setSaved(true);
    } catch (err) {
      message.error(err.response?.data?.message || "Failed to save venue details");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) return (
    <App>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"60vh", flexDirection:"column", gap:14 }}>
        <div className="mhv-spinner" />
        <p style={{ color:C_TEXT_MUTED, fontSize:14, fontWeight:600 }}>Loading venue details…</p>
      </div>
    </App>
  );

  return (
    <App>
      <div className="mhv-page">
        <div className="mhv-wrap">
          {/* ── Page Header ── */}
          <div className="mhv-header">
            <div>
              <div className="mhv-eyebrow">
                <span className="mhv-eyebrow-dot" />
                Hero Venue Configuration
              </div>
              <h1 className="mhv-title">Manage <span className="mhv-grad">Main Venue</span></h1>
              <p className="mhv-sub">Update the conference location page content in real-time.</p>
            </div>
            {/* Save button removed from here, moved to the floating container below */}
          </div>

          <form onSubmit={handleSubmit} className="mhv-form">

            {/* ── 1. Basic Info ── */}
            <div className="mhv-card">
              <div className="mhv-card-hd">
                <div className="mhv-card-icon">
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                </div>
                <h3 className="mhv-card-title">Basic Information</h3>
              </div>
              <div className="mhv-grid-2">
                <div className="mhv-field">
                  <label>Venue Title</label>
                  <input name="title" value={formData.title} onChange={handleChange} placeholder="e.g. Buntara Bhavana Pune" required />
                </div>
                <div className="mhv-field">
                  <label>Subtitle</label>
                  <input name="subtitle" value={formData.subtitle} onChange={handleChange} placeholder="e.g. Where Expertise Meets Excellence" required />
                </div>
                <div className="mhv-field">
                  <label>Address Badge (Short)</label>
                  <input name="addressBadge" value={formData.addressBadge} onChange={handleChange} placeholder="e.g. Baner, Pune — 411 045" />
                </div>
              </div>
            </div>

            {/* ── 2. Descriptions ── */}
            <div className="mhv-card">
              <div className="mhv-card-hd">
                <div className="mhv-card-icon">
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                </div>
                <h3 className="mhv-card-title">Detailed Descriptions</h3>
              </div>
              <div className="mhv-grid-1">
                <div className="mhv-field">
                  <label>Description Part 1</label>
                  <textarea name="descriptionPart1" value={formData.descriptionPart1} onChange={handleChange} rows="3" placeholder="First paragraph describing the venue…" />
                </div>
                <div className="mhv-field">
                  <label>Description Part 2</label>
                  <textarea name="descriptionPart2" value={formData.descriptionPart2} onChange={handleChange} rows="3" placeholder="Second paragraph with event details…" />
                </div>
              </div>
            </div>

            {/* ── 3. Map ── */}
            <div className="mhv-card">
              <div className="mhv-card-hd">
                <div className="mhv-card-icon">
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/><line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/></svg>
                </div>
                <h3 className="mhv-card-title">Map & Location</h3>
              </div>
              <div className="mhv-grid-1">
                <div className="mhv-field">
                  <label>Google Maps Embed URL (src link)</label>
                  <input name="mapEmbedUrl" value={formData.mapEmbedUrl} onChange={handleChange} placeholder="https://www.google.com/maps/embed?pb=…" />
                </div>
                <div className="mhv-field">
                  <label>Full Address Text</label>
                  <textarea name="mapAddressText" value={formData.mapAddressText} onChange={handleChange} rows="2" placeholder="Full street address shown on the map card…" />
                </div>
              </div>
            </div>

            {/* ── 4. Gallery Photos ── */}
            <div className="mhv-card">
              <div className="mhv-card-hd">
                <div className="mhv-card-icon">
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                </div>
                <h3 className="mhv-card-title">Venue Gallery Photos</h3>
              </div>
              
              <p className="mhv-field-hint" style={{ marginBottom:18 }}>
                Upload up to <strong>10 images</strong> from your device. Each must be <strong>under 300 KB</strong>. Supported: JPG, PNG, WebP.
              </p>
              
              <div className="mhv-photos-grid">
                {formData.photos.map((item, i) => (
                  <div className="mhv-photo-item" key={i}>
                    <ImageUploadField
                      value={item}
                      index={i}
                      onChange={(newFile) => handleArrayChange("photos", i, null, newFile)}
                    />
                    {formData.photos.length > 1 && (
                      <button type="button" className="mhv-photo-del" onClick={() => removeArrayItem("photos", i)} title="Remove photo">
                        <TrashIcon />
                      </button>
                    )}
                  </div>
                ))}
              </div>
              
              {formData.photos.length < 10 ? (
                <button type="button" className="mhv-add-btn" onClick={() => addArrayItem("photos", "")}>
                  <PlusIcon /> Add Photo Slot
                </button>
              ) : (
                <p style={{ fontSize: "12.5px", color: "#f59e0b", marginTop: "12px", fontWeight: "600" }}>
                  Maximum of 10 images reached.
                </p>
              )}
            </div>

            {/* ── 5. Highlights ── */}
            <div className="mhv-card">
              <div className="mhv-card-hd">
                <div className="mhv-card-icon">
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                </div>
                <h3 className="mhv-card-title">Event Highlights</h3>
              </div>
              {formData.highlights.map((h, i) => (
                <div className="mhv-dyn-row" key={i}>
                  <input
                    value={h.value}
                    onChange={e => handleArrayChange("highlights", i, "value", e.target.value)}
                    placeholder="Value (e.g. 800+)"
                    style={{ width:"28%" }}
                  />
                  <input
                    value={h.label}
                    onChange={e => handleArrayChange("highlights", i, "label", e.target.value)}
                    placeholder="Label (e.g. Global Delegates)"
                    style={{ flex:1 }}
                  />
                  <button type="button" className="mhv-del-btn" onClick={() => removeArrayItem("highlights", i)}><TrashIcon /></button>
                </div>
              ))}
              <button type="button" className="mhv-add-btn" onClick={() => addArrayItem("highlights", { value:"", label:"" })}>
                <PlusIcon /> Add Highlight
              </button>
            </div>

            {/* ── 6. Distances ── */}
            <div className="mhv-card">
              <div className="mhv-card-hd">
                <div className="mhv-card-icon">
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>
                </div>
                <h3 className="mhv-card-title">Quick Access / Distances</h3>
              </div>
              <p className="mhv-field-hint" style={{ marginBottom:12 }}>Click the icon button to choose a transport icon.</p>
              {formData.distances.map((d, i) => (
                <div className="mhv-dyn-row" key={i}>
                  <IconPicker
                    value={d.iconName}
                    keys={DISTANCE_ICON_KEYS}
                    label="transport icon"
                    onChange={v => handleArrayChange("distances", i, "iconName", v)}
                  />
                  <input
                    value={d.label}
                    onChange={e => handleArrayChange("distances", i, "label", e.target.value)}
                    placeholder="Label (e.g. Pune Airport)"
                    style={{ flex:1 }}
                  />
                  <input
                    value={d.value}
                    onChange={e => handleArrayChange("distances", i, "value", e.target.value)}
                    placeholder="Distance (e.g. 18 km)"
                    style={{ width:"26%" }}
                  />
                  <button type="button" className="mhv-del-btn" onClick={() => removeArrayItem("distances", i)}><TrashIcon /></button>
                </div>
              ))}
              <button type="button" className="mhv-add-btn" onClick={() => addArrayItem("distances", { iconName:"PinIcon", label:"", value:"" })}>
                <PlusIcon /> Add Distance
              </button>
            </div>

            {/* ── 7. Amenities ── */}
            <div className="mhv-card" style={{ marginBottom:0 }}>
              <div className="mhv-card-hd">
                <div className="mhv-card-icon">
                  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                </div>
                <h3 className="mhv-card-title">Venue Amenities</h3>
              </div>
              <p className="mhv-field-hint" style={{ marginBottom:12 }}>Click the icon button to choose an amenity icon.</p>
              {formData.amenities.map((a, i) => (
                <div className="mhv-dyn-row" key={i}>
                  <IconPicker
                    value={a.iconName}
                    keys={AMENITY_ICON_KEYS}
                    label="amenity icon"
                    onChange={v => handleArrayChange("amenities", i, "iconName", v)}
                  />
                  <input
                    value={a.label}
                    onChange={e => handleArrayChange("amenities", i, "label", e.target.value)}
                    placeholder="Amenity Name (e.g. High-Speed WiFi)"
                    style={{ flex:1 }}
                  />
                  <input
                    value={a.desc}
                    onChange={e => handleArrayChange("amenities", i, "desc", e.target.value)}
                    placeholder="Description (e.g. Seamless connectivity)"
                    style={{ flex:1 }}
                  />
                  <button type="button" className="mhv-del-btn" onClick={() => removeArrayItem("amenities", i)}><TrashIcon /></button>
                </div>
              ))}
              <button type="button" className="mhv-add-btn" onClick={() => addArrayItem("amenities", { iconName:"AmWifi", label:"", desc:"" })}>
                <PlusIcon /> Add Amenity
              </button>
            </div>

          </form>
        </div>
      </div>

      {/* ── Floating Actions Container ── */}
      <div className="mhv-floating-actions">
        <FloatingPreview saved={saved} />
        
        <button className="mhv-save-btn mhv-save-floating" onClick={handleSubmit} disabled={loading}>
          {loading ? (
            <><span className="mhv-btn-spin" /> Saving…</>
          ) : (
            <><SaveIcon /> Save Changes</>
          )}
        </button>
      </div>

      <style>{`
        @keyframes mhv-spin  { to { transform: rotate(360deg) } }
        @keyframes mhv-pulse { 0%,100%{ opacity:1 } 50%{ opacity:.35 } }
        @keyframes mhv-pop   { from { opacity:0; transform:translateY(6px) scale(0.96) } to { opacity:1; transform:translateY(0) scale(1) } }
        @keyframes mhv-fadein{ from { opacity:0 } to { opacity:1 } }

        * { box-sizing: border-box; }

        /* ── Page ── */
        .mhv-page {
          background: ${C_SOFT_BG}; min-height: 100vh;
          padding: 32px 0 120px; font-family: inherit;
        }
        .mhv-wrap { max-width: 920px; margin: 0 auto; padding: 0 28px; }

        /* ── Header ── */
        .mhv-header {
          display: flex; align-items: flex-start; justify-content: space-between;
          flex-wrap: wrap; gap: 18px; margin-bottom: 32px;
        }
        .mhv-eyebrow {
          display: inline-flex; align-items: center; gap: 8px;
          background: rgba(240,77,160,0.08); border: 1px solid rgba(240,77,160,0.2);
          color: ${C_PINK}; font-size: 11px; font-weight: 800;
          letter-spacing: 0.13em; text-transform: uppercase;
          padding: 5px 12px; border-radius: 50px; margin-bottom: 10px; width: fit-content;
        }
        .mhv-eyebrow-dot {
          width: 7px; height: 7px; border-radius: 50%; background: ${C_PINK};
          animation: mhv-pulse 2s infinite;
        }
        .mhv-title {
          font-size: clamp(24px, 3vw, 32px); font-weight: 800;
          color: ${C_TEXT_MAIN}; margin: 0 0 6px;
        }
        .mhv-grad {
          background: linear-gradient(90deg, ${C_PINK}, ${C_PURPLE});
          -webkit-background-clip: text; -webkit-text-fill-color: transparent;
        }
        .mhv-sub { font-size: 13.5px; color: ${C_TEXT_MUTED}; margin: 0; }

        /* ── Form ── */
        .mhv-form { display: flex; flex-direction: column; gap: 22px; }
        .mhv-card {
          background: #fff; border-radius: 20px; padding: 26px 28px;
          border: 1px solid rgba(139,47,201,0.08);
          box-shadow: 0 4px 20px rgba(0,0,0,0.04);
        }
        .mhv-card-hd {
          display: flex; align-items: center; gap: 12px; margin-bottom: 22px;
          padding-bottom: 14px; border-bottom: 1.5px solid #f5eeff;
        }
        .mhv-card-icon {
          width: 36px; height: 36px; border-radius: 10px; flex-shrink: 0;
          background: rgba(240,77,160,0.08); border: 1px solid rgba(240,77,160,0.18);
          display: flex; align-items: center; justify-content: center; color: ${C_PINK};
        }
        .mhv-card-title { font-size: 15px; font-weight: 800; color: ${C_PURPLE}; margin: 0; }

        .mhv-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .mhv-grid-1 { display: grid; grid-template-columns: 1fr; gap: 16px; }

        .mhv-field { display: flex; flex-direction: column; gap: 6px; }
        .mhv-field label {
          font-size: 11.5px; font-weight: 700; color: ${C_TEXT_MUTED};
          text-transform: uppercase; letter-spacing: 0.06em;
        }
        .mhv-field input, .mhv-field textarea,
        .mhv-dyn-row input {
          padding: 11px 14px; border-radius: 10px;
          border: 1.5px solid #ede5f5; background: #fcfaff;
          font-size: 13.5px; color: ${C_TEXT_MAIN}; outline: none;
          transition: border-color .2s, box-shadow .2s; font-family: inherit;
          width: 100%;
        }
        .mhv-field input:focus, .mhv-field textarea:focus, .mhv-dyn-row input:focus {
          border-color: ${C_PINK}; box-shadow: 0 0 0 3px rgba(240,77,160,0.1); background: #fff;
        }
        .mhv-field-hint { font-size: 12.5px; color: #9a86b8; margin: 0; }

        /* ── Dynamic rows ── */
        .mhv-dyn-row {
          display: flex; gap: 10px; margin-bottom: 10px; align-items: center;
        }
        .mhv-del-btn {
          width: 36px; height: 36px; flex-shrink: 0; border-radius: 9px; border: none;
          background: rgba(248,113,113,0.08); border: 1px solid rgba(248,113,113,0.2);
          color: #f87171; display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: background .2s, transform .15s;
        }
        .mhv-del-btn:hover { background: rgba(248,113,113,0.18); transform: scale(1.06); }

        .mhv-add-btn {
          display: inline-flex; align-items: center; gap: 7px;
          background: rgba(139,47,201,0.07); color: ${C_PURPLE};
          border: 1px solid rgba(139,47,201,0.18);
          padding: 9px 16px; border-radius: 10px;
          font-size: 12.5px; font-weight: 700; cursor: pointer;
          transition: background .2s; margin-top: 4px; font-family: inherit;
        }
        .mhv-add-btn:hover { background: rgba(139,47,201,0.14); }

        /* ── Gallery Photos ── */
        .mhv-photos-grid {
          display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
          gap: 14px; margin-bottom: 14px;
        }
        .mhv-photo-item { position: relative; }
        .mhv-photo-del {
          position: absolute; top: -8px; right: -8px; z-index: 10;
          width: 26px; height: 26px; border-radius: 50%; border: none;
          background: #ef4444; color: #fff;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; box-shadow: 0 2px 8px rgba(239,68,68,.4);
          transition: transform .2s;
        }
        .mhv-photo-del:hover { transform: scale(1.12); }

        /* ── Image Upload ── */
        .img-upload-wrap { width: 100%; }
        .img-drop-zone {
          width: 100%; min-height: 130px; border-radius: 12px;
          border: 2px dashed #e0d0f0; background: #fdfbff;
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          gap: 7px; cursor: pointer;
          transition: border-color .2s, background .2s;
        }
        .img-drop-zone:hover { border-color: ${C_PINK}; background: #fff8fc; }
        .img-drop-label { font-size: 12.5px; font-weight: 700; color: ${C_TEXT_MAIN}; }
        .img-drop-hint  { font-size: 11px; color: #9a86b8; }

        .img-preview-box {
          position: relative; border-radius: 12px; overflow: hidden;
          aspect-ratio: 4/3; border: 1.5px solid rgba(240,77,160,0.25);
          box-shadow: 0 4px 14px rgba(26,0,64,.06);
        }
        .img-preview-thumb {
          width: 100%; height: 100%; object-fit: cover; display: block;
        }
        .img-preview-actions {
          position: absolute; bottom: 0; left: 0; right: 0;
          background: linear-gradient(to top, rgba(26,0,64,.7) 0%, transparent 100%);
          padding: 20px 10px 8px; display: flex; justify-content: center;
          opacity: 0; transition: opacity .2s;
        }
        .img-preview-box:hover .img-preview-actions { opacity: 1; }
        .img-act-btn {
          display: inline-flex; align-items: center; gap: 5px;
          padding: 5px 12px; background: rgba(255,255,255,.9); border: none;
          border-radius: 8px; font-size: 11.5px; font-weight: 700;
          color: ${C_TEXT_MAIN}; cursor: pointer; font-family: inherit;
          transition: background .2s;
        }
        .img-act-btn:hover { background: #fff; }
        .img-size-badge {
          position: absolute; top: 7px; left: 8px;
          background: rgba(26,0,64,.55); color: #fff;
          font-size: 10.5px; font-weight: 700; padding: 2px 7px;
          border-radius: 6px; letter-spacing: .03em;
        }

        /* ── Icon Picker ── */
        .icon-pick-btn {
          display: inline-flex; align-items: center; gap: 4px;
          padding: 9px 12px; border-radius: 10px; flex-shrink: 0;
          background: rgba(139,47,201,0.07); border: 1.5px solid rgba(139,47,201,0.2);
          cursor: pointer; transition: background .2s, border-color .2s;
          font-family: inherit;
        }
        .icon-pick-btn:hover { background: rgba(139,47,201,0.13); border-color: rgba(139,47,201,0.35); }

        .icon-picker-dropdown {
          position: absolute; top: calc(100% + 6px); left: 0; z-index: 999;
          background: #fff; border-radius: 14px;
          border: 1px solid #ede5f5; box-shadow: 0 16px 40px rgba(26,0,64,.14);
          padding: 12px; min-width: 200px;
          animation: mhv-pop .18s ease;
        }
        .icon-picker-label {
          font-size: 10.5px; font-weight: 800; color: #9a86b8;
          text-transform: uppercase; letter-spacing: .1em;
          margin-bottom: 10px; padding-bottom: 7px; border-bottom: 1px solid #f3ecfa;
        }
        .icon-picker-grid {
          display: grid; grid-template-columns: repeat(5, 1fr); gap: 6px;
        }
        .icon-opt {
          width: 36px; height: 36px; border-radius: 9px; border: none;
          display: flex; align-items: center; justify-content: center;
          background: #f6f0fc; color: ${C_PURPLE}; cursor: pointer;
          transition: background .15s, transform .15s; font-family: inherit;
          border: 1.5px solid transparent;
        }
        .icon-opt:hover { background: rgba(240,77,160,0.12); border-color: rgba(240,77,160,0.3); transform: scale(1.1); }
        .icon-opt--active {
          background: ${C_GRAD}; color: #fff;
          border-color: transparent; box-shadow: 0 4px 12px rgba(240,77,160,0.3);
        }

        /* ── NEW: Floating Actions Container ── */
        .mhv-floating-actions {
          position: fixed;
          bottom: 32px;
          right: 32px;
          z-index: 9998;
          display: flex;
          align-items: center;
          gap: 16px;
        }

        /* ── Save button (Floating Style) ── */
        .mhv-save-btn {
          display: inline-flex; align-items: center; gap: 8px;
          background: ${C_GRAD}; color: #fff;
          font-weight: 700; border: none;
          cursor: pointer;
          transition: transform 0.25s, box-shadow 0.25s; 
          white-space: nowrap; flex-shrink: 0;
          font-family: inherit;
        }
        .mhv-save-floating {
          padding: 15px 28px;
          border-radius: 50px;
          font-size: 15px;
          box-shadow: 0 8px 28px rgba(240,77,160,0.4);
        }
        .mhv-save-floating:hover:not(:disabled) { 
          transform: translateY(-3px); 
          box-shadow: 0 12px 34px rgba(240,77,160,0.5); 
        }
        .mhv-save-btn:disabled { opacity: 0.7; cursor: not-allowed; }
        
        .mhv-btn-spin {
          width: 14px; height: 14px; border-radius: 50%;
          border: 2px solid rgba(255,255,255,.3); border-top: 2px solid #fff;
          animation: mhv-spin .7s linear infinite; display: inline-block;
        }

        /* ── Floating Preview ── */
        .float-preview-btn {
          position: relative;
          display: inline-flex; align-items: center; gap: 0;
          background: #fff; color: ${C_PURPLE};
          border-radius: 50px; text-decoration: none;
          box-shadow: 0 6px 20px rgba(26,0,64,0.06);
          transition: box-shadow .25s, padding .25s, transform .2s;
          padding: 14px; overflow: hidden;
          border: 1.5px solid rgba(139,47,201,0.12);
        }
        .float-preview-btn:hover {
          box-shadow: 0 10px 28px rgba(139,47,201,0.12);
          padding: 14px 22px 14px 16px;
          transform: translateY(-2px);
        }
        .float-icon { display: flex; align-items: center; flex-shrink: 0; }
        .float-label {
          font-size: 13.5px; font-weight: 700; white-space: nowrap;
          max-width: 0; overflow: hidden;
          transition: max-width .3s ease, margin-left .3s ease;
          margin-left: 0; display: flex; align-items: center;
        }
        .float-label--show { max-width: 180px; margin-left: 9px; }
        .float-dot {
          position: absolute; top: 10px; right: 10px;
          width: 8px; height: 8px; border-radius: 50%;
          background: #f04da0; border: 2px solid #fff;
          animation: mhv-pulse 1.8s infinite;
        }

        /* ── Loading spinner ── */
        .mhv-spinner {
          width: 36px; height: 36px; border-radius: 50%;
          border: 3px solid rgba(240,77,160,0.18);
          border-top: 3px solid ${C_PINK};
          animation: mhv-spin .75s linear infinite;
        }

        /* ── Responsive ── */
        @media (max-width: 768px) {
          .mhv-wrap  { padding: 0 16px; }
          .mhv-page  { padding: 20px 0 100px; }
          .mhv-grid-2 { grid-template-columns: 1fr; }
          .mhv-header { flex-direction: column; align-items: stretch; }
          .mhv-dyn-row { flex-wrap: wrap; background: #fdfbff; padding: 12px; border-radius: 11px; border: 1px dashed #ede5f5; }
          .mhv-dyn-row input { width: 100% !important; }
          .mhv-photos-grid { grid-template-columns: repeat(2, 1fr); }
          .mhv-card { padding: 20px; border-radius: 16px; }
          
          /* Stack buttons vertically on small screens */
          .mhv-floating-actions { 
            bottom: 20px; right: 20px; 
            flex-direction: column-reverse; 
            align-items: flex-end; 
            gap: 12px; 
          }
          .mhv-save-floating { padding: 14px 24px; font-size: 14px; }
        }
      `}</style>
    </App>
  );
};

export default ManageHeroVenue;